export const SourceReliabilityFailOnFit = "reliabilityfailonfits";
